import {Component, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './services/resources/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'web';

  constructor(private languageService: LanguageService,
              private translate: TranslateService) {
    this.translate.addLangs(['de', 'en']);
    this.translate.setFallbackLang('de');
    this.translate.use('de');
  }

  ngOnInit() {
    this.languageService.getAll({lazyLoad: true})
  }

}
